export default __webpack_public_path__ + "static/media/ibm.39809b67.svg";